// 조직(부서 / 직급 / 구성원)
//
// store/index.js 가 이 조각들을 펼쳐 하나의 루트 스토어로 합친다.
// Vuex 의 modules 옵션이 아니라 "조각"인 이유: Vuex 는 namespaced 여부와 무관하게
// 모듈 state 를 모듈 이름 아래에 중첩시킨다. 진짜 모듈로 바꾸면 store.state.tasks 가
// store.state.tasks.tasks 가 되어 소비자 40곳을 전부 고쳐야 한다.
// 조각 합성은 동작이 100% 동일하면서 파일만 나눈다.
//
// 액션은 실패를 그대로 던진다 — 호출부가 자기 문맥의 메시지로 알린다(store/modules/reports.js 와 같은 규칙).

import http from '@/utils/http'

export const state = {
  orgDepartments: [],
  orgPositions: [],
  orgUsers: []
}

export const mutations = {
  SET_ORG_DEPARTMENTS(state, departments) {
    state.orgDepartments = departments
  },

  SET_ORG_POSITIONS(state, positions) {
    state.orgPositions = positions
  },

  SET_ORG_USERS(state, users) {
    state.orgUsers = users
  }
}

export const actions = {
  // 트리는 조직도 화면만 쓰고 미배정 구성원과 함께 받으므로 state 에 두지 않고 응답을 그대로 돌려준다
  async fetchOrgTree() {
    const response = await http.get(`/api/org/tree`)
    return response.data
  },

  async fetchOrgUsers({ commit }) {
    const response = await http.get(`/api/org/users`)
    commit('SET_ORG_USERS', response.data.users || [])
    return response.data.users || []
  },

  async fetchDepartments({ commit }) {
    const response = await http.get(`/api/org/departments`)
    commit('SET_ORG_DEPARTMENTS', response.data.departments || [])
    return response.data.departments || []
  },

  async createDepartment({ dispatch }, data) {
    const response = await http.post(`/api/org/departments`, data)
    await dispatch('fetchDepartments')
    return response.data.department
  },

  async updateDepartment({ dispatch }, { id, data }) {
    const response = await http.put(`/api/org/departments/${id}`, data)
    await dispatch('fetchDepartments')
    return response.data.department
  },

  async deleteDepartment({ dispatch }, id) {
    await http.delete(`/api/org/departments/${id}`)
    await dispatch('fetchDepartments')
  },

  async fetchPositions({ commit }) {
    const response = await http.get(`/api/org/positions`)
    commit('SET_ORG_POSITIONS', response.data.positions || [])
    return response.data.positions || []
  },

  async createPosition({ dispatch }, data) {
    const response = await http.post(`/api/org/positions`, data)
    await dispatch('fetchPositions')
    return response.data.position
  },

  async updatePosition({ dispatch }, { id, data }) {
    const response = await http.put(`/api/org/positions/${id}`, data)
    await dispatch('fetchPositions')
    return response.data.position
  },

  async deletePosition({ dispatch }, id) {
    await http.delete(`/api/org/positions/${id}`)
    await dispatch('fetchPositions')
  },

  async assignUserOrg(_, { userId, departmentId, positionId, managerId }) {
    const response = await http.patch(`/api/org/users/${userId}/assignment`, { departmentId, positionId, managerId })
    return response.data.user
  },

  async fetchManagerChain(_, userId) {
    const response = await http.get(`/api/org/users/${userId}/manager-chain`)
    return response.data.approvers || []
  }
}
